import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";
import {SettingsSection, SettingsSectionTitleDict} from "../../../app/settings/@const";

// const debug = "PortfolioModule"
const debug = false

export class PortfolioModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.PORTFOLIO, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Portfolio"
        this.description                = "The Portfolio module streamlines the management of multiple projects, offering a unified view for overseeing the entire project landscape. It facilitates efficient resource allocation, project status tracking, and overall performance assessment. Essential for organizations aiming to manage their project portfolios with greater efficacy, this module ensures strategic objectives are met and project outcomes optimized."
        this.svgIcon                    = "isvg-portfolio"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.settingsSection            = SettingsSection.TASKS_PROJECTS
        this.settingsUrl                = "settings/portfolio"
        this.typeLabel                  = SettingsSectionTitleDict[this.settingsSection]
        this.parentSection              = SettingsParentSection.TASKS_PROJECTS

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false
    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}